import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { DevicesService } from '../../../devices/devices.service';
import { SchedulingService } from '../../scheduling.service';
import { SchedulingUtils } from '../../shedulling.utils';
import { GeneralService } from '../../../../shared/services/general.service';
import { SharedUtils } from '../../../../shared/shared.utils';
import { Schedule } from '../../scheduling.model';
import { ScheduleType } from '../../../../shared/constants';
import { SCHEDULE_TYPE } from '../../scheduling.constants';
import { Device } from '../../../devices/devices.model_new';

@Component({
  selector: 'app-scheduling-card',
  templateUrl: './scheduling-card.component.html',
  styleUrls: ['./scheduling-card.component.scss']
})
export class SchedulingCardComponent implements OnInit, OnChanges {
  @Input()
  device: Device;
  @Input()
  schedules: Schedule[];

  scheduleWeekDays: string;
  scheduleHorary: string;

  SharedUtils = SharedUtils;

  constructor(private devicesService: DevicesService,
    private schedulingService: SchedulingService,
    private generalService: GeneralService) { }

  ngOnInit() {
    this.onStateChange();
  }

  ngOnChanges() {
    this.onStateChange();
  }

  private onStateChange() {
    const fullSchedule: string[] = SchedulingUtils.formatSchedulesForDeviceList(this.schedules).split(' | ');
    if (this.hasSchedules()) {
      if (fullSchedule[0] !== 'Multiple Schedules') {
        this.scheduleWeekDays = this.auxTranslate(fullSchedule[0]);
        this.scheduleHorary = this.schedules[0].getType() !== SCHEDULE_TYPE.ECONOMIC ? this.auxTranslate(fullSchedule[1]) : '';
      } else {
        this.scheduleWeekDays = fullSchedule[0];
        this.scheduleHorary = this.schedules[0].getType() !== SCHEDULE_TYPE.ECONOMIC ? fullSchedule[1] : '';
      }
    }
  }

  hasSchedules(): boolean {
    return this.schedules.length > 0;
  }

  auxTranslate(s: string): string {
    const auxTranslate = s.split(' ');
    let translation = '';
    auxTranslate.forEach(element => {
      if (element !== '') {
        translation = translation.concat(this.generalService.translate.instant(element) + ' ');
      }
    });
    return translation;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-tab/scheduling-card/scheduling-card.component.ts